module.exports = __webpack_public_path__ + "static/media/support_07@3x.24f67533.png";